export default __webpack_public_path__ + "assets/images/git.0acab55.png";